<template>
    <span v-html="text"></span>
</template>

<script>
export default {
    name: "cCounter",
    props: {
        date: String,
    },
    emits: ["ended"],
    data() {
        return {
            text: "",
        };
    },
    mounted() {
        this.countdown();
    },
    beforeUnmount() {
        clearTimeout(this.timeout);
    },
    methods: {
        countdown() {
            const end = new Date(this.date);
            const now = new Date().getTime();

            const diff = end - now;

            if (diff < 0) {
                this.$emit("ended");
                return;
            }

            const days = Math.floor(diff / (1000 * 60 * 60) / 24);
            const hours = Math.floor(diff / (1000 * 60 * 60)) - days * 24;
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            const daysLabel = this.$t("r_shared.counter.days", days);
            const hoursLabel = this.$t("r_shared.counter.hours", hours);
            const minutesLabel = this.$t("r_shared.counter.minutes", minutes);
            const secondsLabel = this.$t("r_shared.counter.seconds", seconds);

            let text = "";

            if (days > 0) {
                text += `${days}&nbsp;${daysLabel} `;
            }

            if (hours > 0) {
                text += `${hours}&nbsp;${hoursLabel} `;
            }

            if (minutes > 0) {
                text += `${minutes}&nbsp;${minutesLabel} `;
            }

            text += `${seconds}&nbsp;${secondsLabel}`;

            this.text = text;

            this.timeout = setTimeout(this.countdown.bind(this), 1000);
        },
    },
};
</script>
